import { useMutation } from '@tanstack/react-query';
import type { AgentApiCsvMappingTemplatesShow } from '@/types/serializers';

interface CreateCsvMappingTemplateParams {
  title: string;
  import_request_id: string;
}

export const useCreateCsvMappingTemplate = () => {
  return useMutation({
    mutationFn: async (params: CreateCsvMappingTemplateParams) => {
      const response = await fetch('/agent/api/csv_mapping_templates', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || '',
        },
        body: JSON.stringify(params),
      });

      if (!response.ok) {
        const errorData = await response
          .json()
          .catch(() => ({ message: 'テンプレートの作成に失敗しました' }));
        throw new Error(errorData.message || 'テンプレートの作成に失敗しました');
      }

      const data: AgentApiCsvMappingTemplatesShow = await response.json();
      return data;
    },
  });
};
